import L from 'leaflet';
import 'leaflet.vectorgrid/dist/Leaflet.VectorGrid.bundled';
import PropTypes from 'prop-types';
import { GridLayer } from 'react-leaflet';
import { railroads } from '../../../config';

export default class VectorGridLayer extends GridLayer {
  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.bool,
      PropTypes.arrayOf(PropTypes.element),
    ]),
    opacity: PropTypes.number,
    url: PropTypes.string.isRequired,
    zIndex: PropTypes.number,
  };

  createLeafletElement(props) {
    const { url, ...options } = props;
    const defaultStyles = color => (properties, zoom) => {
      let weight = 1.1;
      if (zoom < 6) {
        weight = 0.9;
      }
      return { weight, color, fillColor: color, fillOpacity: 0, fill: false };
    };
    const cpkcStyles = color => ({ _symbol }, zoom) => {
      let weight = 1.5;
      let type;
      let dashArray = '';
      if (zoom < 6) {
        weight = 0.9;
      }
      switch (_symbol) {
        case 0:
          type = 'CPKC Network';
          weight = 2;
          break;
        case 1:
          type = 'Trackage or Haulage';
          dashArray = '4, 3';
          break;
        case 2:
          type = 'Trackage or Haulage';
          dashArray = '4, 3';
          break;
        case 3:
          type = 'Leased Track';
          dashArray = '10, 8';
          break;
        default:
          type = 'Other';
          dashArray = '12, 3';
      }
      return { weight, type, color, dashArray, fill: false, fillOpacity: 0 };
    };
    const vectorTileOptions = {
      vectorTileLayerStyles: {
        Amtrak: defaultStyles(railroads.Amtrak.color),
        BNSF_TRK_11302020: defaultStyles(railroads.BNSF.color),
        CN: defaultStyles(railroads['Canadian National'].color),
        'CPKC 101 NETWORK': cpkcStyles(railroads.CPKC.color),
        CSX: defaultStyles(railroads.CSX.color),
        Norfolk_Southern: defaultStyles(railroads['Norfolk Southern'].color),
        OmniTRAX: defaultStyles(railroads.OmniTRAX.color),
        'Tulsa-Sapulpa': defaultStyles(railroads['Tulsa-Sapulpa'].color),
        UP: defaultStyles(railroads['Union Pacific'].color),
        WATCO: defaultStyles(railroads.WATCO.color),
      },
      rendererFactory: L.canvas.tile,
      ...options,
    };
    const newL = L.vectorGrid.protobuf(url, vectorTileOptions);
    return newL;
  }

  updateLeafletElement(fromProps, toProps) {
    super.updateLeafletElement(fromProps, toProps);
    if (toProps.url !== fromProps.url) {
      this.leafletElement.vectorGrid.protobuf(toProps.url);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Map/Layers/VectorGridLayer.js